import { type BasketDiscount } from "../../types";

import { getNumberOfProductsCap } from "./get-number-of-products-cap";
import { type KioskDisplayProductList } from "./types";

/**
 * Single source of truth for which discount + allowance cap apply when adding a
 * display product to the basket. `discountOverride` lets callers pick a specific
 * discount (e.g. a stamp-card or a barcode-matched one); otherwise the product's
 * first discount is used.
 */
export function getDisplayProductBasketDiscount(
  item: KioskDisplayProductList,
  discountOverride?: BasketDiscount
) {
  const discount = discountOverride ?? item.discounts[0] ?? undefined;
  const allowanceCap = getNumberOfProductsCap(item.allowance, discount);

  return { discount, allowanceCap };
}
